// removed by extract-text-webpack-plugin
module.exports = {"infoWindow":"MapBox_infoWindow__2ld_","loader":"MapBox_loader__1PPD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Map/MapBox/MapBox.scss
// module id = 522
// module chunks = 0